import { useRef } from "react";
import PropTypes from "prop-types";
import { Clock } from "lucide-react";
import { RANGE_TYPE_LABELS } from "../../lib/utils/constants";
import TimezonePicker from "../../lib/components/TimezonePicker/TimezonePicker";
import CustomDatePicker from "../../lib/components/Datepicker/CustomDatePicker";

const PRESET_OPTIONS = [
  { label: "Today", value: RANGE_TYPE_LABELS.DAY_1 },
  { label: "7 Days", value: RANGE_TYPE_LABELS.DAY_7 },
  { label: "15 Days", value: RANGE_TYPE_LABELS.DAY_15 },
  { label: "30 Days", value: RANGE_TYPE_LABELS.DAY_30 },
];

export function DateRangeToolbar({ activePreset, onPresetChange, onCustomChange, showTimezone = false }) {
  const customDatePickerRef = useRef(null);

  function handlePresetClick(value) {
    if (customDatePickerRef.current?.handleCustomChange) {
      customDatePickerRef.current.handleCustomChange({ target: { value } }, true);
    }
    onPresetChange(value);
  }

  function handleCustomDateChange(range, type) {
    onCustomChange(range, type);
  }

  return (
    <div className="dr-toolbar">
      <span className="dr-toolbar__label">
        <Clock size={14} />
        Time Range
      </span>
      <div className="dr-toolbar__presets">
        {PRESET_OPTIONS.map(opt => (
          <button
            key={opt.value}
            className={`dr-toolbar__pill ${activePreset === opt.value ? "dr-toolbar__pill--active" : ""}`}
            onClick={() => handlePresetClick(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>
      <div className="dr-toolbar__custom-picker">
        <CustomDatePicker
          ref={customDatePickerRef}
          onChange={handleCustomDateChange}
          maxAllowedDays={30}
          initialRange={RANGE_TYPE_LABELS.DAY_7}
          compact
        />
      </div>
      {showTimezone && <TimezonePicker />}
    </div>
  );
}

DateRangeToolbar.propTypes = {
  activePreset: PropTypes.string.isRequired,
  onPresetChange: PropTypes.func.isRequired,
  onCustomChange: PropTypes.func.isRequired,
  showTimezone: PropTypes.bool,
};

export default DateRangeToolbar;
